import { createFileRoute } from '@tanstack/react-router';
import { TodayPage } from '@/features/scheduling/pages/today-page';

export const Route = createFileRoute('/_app/today')({ component: TodayPage });
